import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {ProjectConfig} from 'Global';
import TopBar from "elements/TopBar/TopBar";
import Toolbar from "elements/Toolbar/Toolbar";
import DateBar from "elements/DateBar";
import App from "elements/HtmlEditor/App";
import Cookies from 'universal-cookie';
import 'assets/css/main.css';
import { getCalendarioLiturgicoLabel } from 'hooks/useLabels';

export default function AnoLiturgicoViewer(props: any) {


  /*=======================================
    GET LITUGIA CATEGORY FROM URL
  =======================================*/
  let {category } = useParams();
  /*=======================================
  =======================================*/

  const[category_title, setCategoryTitle] = useState("-");
  var category_t = "-";
  useEffect(() => {    
    switch(category)
    {
      case 'oficio-lectura':
        setCategoryTitle(getCalendarioLiturgicoLabel('oficio_lectura'));
        category_t = "Lit Oficio de lectura";
        break;
      case 'laudes':
        setCategoryTitle(getCalendarioLiturgicoLabel('laudes'));
        category_t = "Lit Laudes";
        break;
      case 'intermedias':
        setCategoryTitle(getCalendarioLiturgicoLabel('horas_intermedias'));
        category_t = "Lit Horas intermedias";
        break;
      case 'visperas':
        setCategoryTitle(getCalendarioLiturgicoLabel('visperas'));
        category_t = "Lit Visperas";
        break;
      case 'completas':
        setCategoryTitle(getCalendarioLiturgicoLabel('completas'));
        category_t = "Lit Completas";
        break;
    }
  }, [category]);

  const cookies = new Cookies();
  const user_id = cookies.get('user_id');
  const lang_id = localStorage.getItem('lang_id') || '1';
  

  /*=======================================
  =======================================*/

  const [loading, setLoading] = useState(true);

  useEffect(() => { props.setLoading(loading); }, [loading]);
  
  const [date, setDate] = useState(localStorage.getItem("date"));
  const [data, setData] = useState<any>();
  
  /*=======================================
    GET DETAILS IF EDITING
  =======================================*/
  useEffect(() => {
    const modulo  = 'Lit ' + category_title;
    setLoading(true);
    axios.get(ProjectConfig.api_url, {
      params: {
        request: "liturgia_horas_dia",
        category: category,
        date: date,
        user_id: user_id,
        modulo: category_t,
        lang_id: lang_id
      },
    })
    .then((response) => {
      console.log("res",response.data);
      const data = response.data;
      console.log(data.color.toLowerCase() === "blanco", {backgroundColor: "#FFFFFF"}, {...data, ...(data.color.toLowerCase() === "blanco" ? {backgroundColor: "#FFFFFF"} : {})});
      setData({...data, ...(data.color.toLowerCase() === "blanco" ? {backgroundColor: "#FFFFFF"} : {})});
    })
    .catch((err) => {
      console.log(err.data);
    })
    .finally(() => {
      setLoading(false);
    });
  }, [date]);
  /*=======================================
  =======================================*/

  const getLectura = () => {
    if(data && data.lectura && typeof data.lectura === "object"){
      return true;
    }
    return false;
  }

  // Función para construir texto de fecha traducido
  const getFullDate = () => {
    if (!data) return '';
    const dayName = getCalendarioLiturgicoLabel(data.dayOfWeekKey || 'domingo').toUpperCase();
    const dayNumber = data.dayNumber || '';
    const monthName = getCalendarioLiturgicoLabel(data.monthKey || 'enero').toUpperCase();
    const de = getCalendarioLiturgicoLabel('de').toUpperCase();
    return `${dayName}, ${dayNumber} ${de} ${monthName}`;
  };

  // Función para construir nombre de semana traducido
  const getWeekName = () => {
    if (!data) return '';
    const dayName = getCalendarioLiturgicoLabel(data.dayOfWeekKey || 'domingo').toUpperCase();
    const semana = getCalendarioLiturgicoLabel('semana').toUpperCase();
    const weekNum = data.weekOfSeason || '';
    const conector = getCalendarioLiturgicoLabel(data.conectorKey || 'de').toUpperCase();
    const seasonName = getCalendarioLiturgicoLabel(data.seasonsKey || 'tiempo_ordinario').toUpperCase();
    return `${dayName} ${semana} ${weekNum} ${conector} ${seasonName}`;
  };

  // Función para obtener el color traducido
  const getColorName = () => {
    if (!data) return '';
    return getCalendarioLiturgicoLabel(data.colorKey || 'color_blanco');
  };
  
  return (
      <div id="AnoLiturgicoViewer" className="module_container">


        <div className="module_topBar">
          <TopBar title={getCalendarioLiturgicoLabel('liturgia_horas_titulo')}/>
          <Toolbar/>
          <DateBar onChange={setDate}/>

          {data &&
          (
            <div id="liturgia_header" style={{
              backgroundColor: data.backgroundColor,
              color: data.textColor,
            }}>
              <span className="ld_category">{category_title.toUpperCase()}</span>
              <span className="ld_date">{getFullDate()}</span>
              <span className="ld_weekName">{getWeekName()}</span>
              <div className="ld_colors">
                <span className="ld_color">{getColorName()}</span>
              </div>
              
              
            </div>
          )}
        </div>
        
        <div className='module_content'>
          
          {getLectura() && (
          <div id="misaLecturaBox">
            {/* parse html */}
            <App
              handleEditorChange={()=>{}}
              content={data.lectura}
              editable={false}
            />
          </div>
          )}

        </div>

      </div>
    
  );
};